export class ControllingService {
  constructor ($log, $http, $q, API, Auth) {
    'ngInject';
    this.$http = $http;
    this.$q = $q;
    this.API = API;
    this.Auth = Auth;
  }

  getProfitCenters() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/profit-centers'
    });
  }
  getRates(id) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/profit-center/' + id + '/rates'
    });
  }

  addRates(rate) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/rates',
      data: rate
    });
  }

  updateRates(id, rates) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/rates/' + id,
      data: rates
    });
  }

  updateAllRates(allRates) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/rates',
      data: allRates
    });
  }

  deleteRate(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/rates/' + id
    });
  }

  getTeams() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/teams'
    });
  }

  getIncomeJson(teamIds, year, month, excludeClientsWithNoTimeReported) {
    const data = {
      teamIds,
      yearMonth: `${year}-${month}`,
      excludeClientsWithNoTimeReported
    };

    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: `${this.API.root}/income/json`,
      data: data
    });
  }

  getIncomeMappers(teamIds, year, month) {
    const data = {
      teamIds,
      yearMonth: `${year}-${month}`
    };

    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: `${this.API.root}/income/mappers`,
      data: data
    });
  }

  getIncomeExcel(teamIds, year, month, excludeClientsWithNoTimeAndIncomeReported) {
    const data = {
      teamIds,
      yearMonth: `${year}-${month}`,
      excludeClientsWithNoTimeAndIncomeReported
    };

    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/income/xlsx',
      responseType: 'blob',
      data: data
    });
  }

  sendIncomeExcel(xlsx_file, teamId, year, month) {
    var fd = new FormData();
    fd.append('file', xlsx_file);
    var url = this.API.root + '/income/xlsx/upload';
    return this.Auth.getFreshUserCredentials().then((user) => {
      return this.$http.post(url, fd, {
        headers: {
          'Content-Type': undefined,
          'Authorization': `Bearer ` + user.token
        },
        params: {teamId, year, month}
      });
    });
  }

  fetchCasemanIncome(teamIds, year, month, excludeClientsWithNoTimeReported) {
    const data = {
      teamIds,
      yearMonth: `${year}-${month}`,
      excludeClientsWithNoTimeReported
    };

    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/income/from-caseman',
      data: data
    });
  }

  fetchCasemanIncomeReport(teamIds, year, month, excludeClientsWithNoTimeReported) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/income/from-caseman/report',
      responseType: 'blob',
      params: {
        teamId: teamIds,
        yearMonth: `${year}-${month}`,
        excludeClientsWithNoTimeReported: excludeClientsWithNoTimeReported
      }
    });
  }

  getAvailableReportFields(){
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/worklog/bigReport/fields'
    });
  }

  downloadBigReport(teamIds, fields, from, to){
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/worklog/bigReport',
      responseType: 'blob',
      params: {
        teamId: teamIds,
        field: fields,
        from: from,
        to: to
      }
    });
  }

  editAmount(data) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/income',
      data
    });
  }

  deleteAmount(id) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/income/' + id
    });
  }
}
